export default {
  // ========== Header ==========
  pa: "PA",
  suitcase: "Instructional",
  didactic: "Kit",
  subjectProgram: "Subject Program",

  // ========== Section 1: General Background ==========
  generalBackground: "General Background",
  totalHours: "Total Hours",
  inPersonDirectTeaching: "In-Person Direct Teaching",
  pedagogicalHours: "Pedagogical Hours",
  nonInPersonDirectTeaching: "Non In-Person Direct Teaching",
  prerequisites: "Prerequisites",
  autonomousWorkChronologicalHours: "Chronological Hours of Autonomous Work",
  noPrerequisites: "No Prerequisites",

  // ========== Section 2: Subject Description ==========
  subjectDescription: "Subject Description",
  noEntityForSubject: "There are no {entity1} for {entity2}.",
  learningResult: "Learning Outcome",
  achievementIndicator: "Achievement Indicator",
  noSubjectDescription: "There is no Subject Description",

  // ========== Section 3: Learning Route Synthesis ==========
  learningRouteSynthesis: "Learning Route Synthesis",
  learningExperience: "Learning Experience",
  activitiesAndEvaluations: "Activities and Evaluations",
  learningEnvironments: "Learning Environments",
  hoursCount: "No. Hours",
  activityAssociatedToVcm: "Activity Associated to VCM",
  total: "Total",
  noLearningRouteSynthesis: "There is no {entity}.",

  // ========== Section 4: Evaluations ==========
  evaluations: "Evaluations",
  evaluation: "Evaluation",
  evaluativeSituation: "Evaluative Situation",
  partialEvaluationWeighting: "Partial Evaluation Weighting (%)",
  finalWeighting: "Final Weighting",
  noPartialEvaluations: "There are no Partial Evaluations.",

  // ========== Section 5: Mandatory Bibliography ==========
  mandatoryBibliography: "Mandatory Bibliography",
  noMandatoryBibliography: "There is no Mandatory Bibliography.",
}
